import { useState, useCallback } from 'react'
import Tabs from '@cloudscape-design/components/tabs'
import SpaceBetween from '@cloudscape-design/components/space-between'
import { RunHistoryTable } from '@/components/results/RunHistoryTable'
import { DashboardSection } from '@/components/results/DashboardSection'
import { DetailedRunView } from '@/components/results/DetailedRunView'
import type { RunHistoryEntry } from '@/components/results/RunHistoryTable'

export function ResultsPage() {
  const [selectedRunId, setSelectedRunId] = useState<string | null>(null)
  const [activeTab, setActiveTab] = useState('history')

  const handleEntriesLoaded = useCallback((entries: RunHistoryEntry[]) => {
    // Auto-select the latest run if nothing is selected yet
    if (!selectedRunId && entries.length > 0) {
      setSelectedRunId(entries[0].id)
    }
  }, [selectedRunId])

  return (
    <Tabs
      activeTabId={activeTab}
      onChange={({ detail }) => setActiveTab(detail.activeTabId)}
      tabs={[
        {
          id: 'history',
          label: 'Run History',
          content: (
            <SpaceBetween size="l">
              <RunHistoryTable
                onSelectRun={setSelectedRunId}
                selectedRunId={selectedRunId}
                onEntriesLoaded={handleEntriesLoaded}
              />
              {selectedRunId && (
                <DetailedRunView
                  runId={selectedRunId}
                  onBack={() => setSelectedRunId(null)}
                />
              )}
            </SpaceBetween>
          ),
        },
        {
          id: 'dashboard',
          label: 'Dashboard',
          content: <DashboardSection />,
        },
      ]}
    />
  )
}
